import "../../utils/tailwind.css";
import cx from "../../utils/tailwind-merge";
import Loader from "react-js-loader";

const CustomButton = ({ children, variant = "default", onClick, disabled = false, isLoading = false, className, ...props }) => {
  const baseStyles = "!rounded-[8px] text-sm transition duration-300 flex items-center justify-center print:hidden";
  const sizeStyles = "!p-0 !px-3 !py-0 !w-fit !h-[28px] text-[12px] !font-semibold !m-0 !w-[130px] !h-[40px] !text-[16px]";

  const buttonVariants = {
    default: `${sizeStyles} bg-[#6A0BB0] !border-none border-[#6A0BB0] text-white hover:bg-[#580d93]`,
    outline: `${sizeStyles} shadow-[inset_0_0_2px_rgba(0,0,0,0.5)] !border-0 !border-b-[1px] !border-[#B5B5B5] text-[#303030]`,
    secondary: `${sizeStyles} bg-[#E3E3E3] border border-[#d1d1d1] text-[#303030] hover:bg-[#e0e0e0]`,
    disabled: `${sizeStyles} bg-[#e5e5e5] border border-[#ccc] text-[#999] cursor-not-allowed`,
    link: `${sizeStyles} !font-bold !border-[#6A0BB0] border-b-[1px] !rounded-[0px] !p-0 !px-0 !h-fit !py-0 text-[#6A0BB0] !shadow-none`,
  };

  const buttonClasses = disabled || isLoading ? buttonVariants.disabled : buttonVariants[variant] || buttonVariants.default;

  return (
    <button className={cx(baseStyles, buttonClasses, className)} onClick={onClick} disabled={disabled || isLoading} {...props}>
      {isLoading ? (
        <>
          <Loader type="bubble-scale" bgColor="white" size={22} />
        </>
      ) : (
        children
      )}
    </button>
  );
};

export default CustomButton;
